/**
 * DBT-053 — annullamento delle fatture: regole e testi, senza interfaccia
 * (provati da fattureAnnulla.test.js). Decisione di Vale del 12/10: una fattura
 * emessa non si elimina, si annulla; resta in elenco barrata, con il suo numero,
 * e l'avviso si legge PRIMA di confermare.
 */

// Annullabili: le emesse non ancora annullate. Le bozze si eliminano.
export const STATI_ANNULLABILI = ['inviata', 'scaduta', 'pagata'];
export const BARRATA = { textDecoration: 'line-through', color: 'var(--ds-muted)' };
export const stileAnnullata = (f) => (f.stato === 'annullata' ? BARRATA : null);

// L'avviso si legge PRIMA di confermare (decisione di Vale del 12/10). Il testo
// cambia se la fattura è già su Fatture in Cloud: lì resta valida.
export function testoAvvisoAnnulla(fattura) {
  const num = fattura.numero ? ` ${fattura.numero}` : '';
  if (fattura.fic_document_id) {
    return [
      `In mAIstro la fattura${num} verrà segnata come annullata e resterà nell'elenco, barrata, con il suo numero.`,
      'Su Fatture in Cloud invece resta valida: mAIstro non la modifica.',
      'Per stornarla devi fare una nota di credito su Fatture in Cloud.',
    ];
  }
  return [
    `La fattura${num} resterà nell'elenco, barrata e segnata come annullata, con il suo numero.`,
    'Non si elimina perché la numerazione delle fatture deve restare senza buchi.',
    'Un\'annullata non conta nei totali e non si può riattivare.',
  ];
}
